import React, {FC} from 'react';
import styled from 'styled-components';
import {createHelpCenterArticleUrl} from '../../../pages/HelpCenter/routes';
import {HelpCenterLandingPageData} from '../../../pages/HelpCenter/types';
import NavigationCard from '../../Card/NavigationCard';
import {TitledGridSection} from '../../Sections/TitledGridSection';

const StyledNavigationCard = styled(NavigationCard)`
  box-sizing: border-box;
  width: 100%;
  &::last-child {
    margin-bottom: 0;
  }
`;

interface Props {
  title: string;
  frequentQuestions: HelpCenterLandingPageData['highlightArticles'];
}

const MobileFrequentQuestions: FC<Props> = ({title, frequentQuestions}) => {
  return (
    <TitledGridSection
      containerDataTestId="HelpCenterTeaserPromotedArticlesContainerMobile"
      mobileOnly
      gridGap={8}
      title={title}
    >
      {frequentQuestions.map(({section, article}) => (
        <StyledNavigationCard
          dataTestId="HelpCenterTeaserPromotedArticle"
          key={`${article.id}_mobile`}
          label={article.name}
          to={createHelpCenterArticleUrl(section, article)}
        />
      ))}
    </TitledGridSection>
  );
};

export default MobileFrequentQuestions;
